<template>
  <div>
    <div class="col-md-6 mt-4">
      <b-input-group
        id="vehicle"
        label="Vehicle Number:"
        label-for="input-1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="input-1"
          v-model="vehicleNumber"
          type="text"
          placeholder="eg. KA5EP6577"
          required
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-success" @click="searchVehicle"
            >Search</b-button
          >
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="col-md-12 my-4 p-0">
      <div class="col-md-12">
        <p v-if="!makingAJAX" class="label m-0 p-0">
          Found {{ traffic_violation.length }} entries of vehicle
          {{ vehicleNumber }}.
        </p>
      </div>
      <div class="col-md-12 m-0 p-0" v-if="!makingAJAX && traffic_violation.length > 0">
        <div class="d-flex col-md-12 my-2">
          <h4 class="mr-2">Total Fine: {{ totalFine }}</h4>
          <h4 class="mr-2">Paid: {{ paidFine }}</h4>
          <h4 class="mr-2">Outstanding: {{ totalFine - paidFine }}</h4>
        </div>
        <div class="row col-md-12 my-4">
          <p class="m-0">Violation History</p>
          <div
            class="col-md-4 m-0 p-2"
            v-for="(data, index) in traffic_violation"
            :key="index"
          >
            <div class="card p-2 m-0">
              <p class="m-0 p-0 label">
                Notice created on: {{ data.NoticeGenerationDate }}
              </p>
              <p class="m-0 p-0">
                Violation Date: {{ data.ViolationDate }} at
                {{ data.ViolationTime }}
              </p>
              <p class="m-0 p-0">Point Name: {{ data.PointName }}</p>
              <p class="m-0 p-0">Description: {{ data.OffenceDescription }}</p>
              <p class="m-0 p-0">
                Fine Amount: {{ data.FineAmount | currency }}
              </p>
              <p class="m-0 p-0">Paid Amount: {{ data.AmountPaid }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="text-center my-5"
        v-if="!makingAJAX && traffic_violation.length == 0"
      >
        <b-icon icon="bag-x" font-scale="5"></b-icon>
        <p class="my-3 label">
          There are no violations reported for vehicle {{ vehicleNumber }}
        </p>
      </div>
      <div class="text-center my-5" v-if="makingAJAX">
        <b-spinner label="Loading..."></b-spinner>
        <p class="my-5">Loading latest content for you.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vehicleNumber: "KA51AF0281",
      totalFine: 0,
      paidFine: 0,
    };
  },
  created() {
    this.searchVehicle();
  },
  watch: {
    traffic_violation() {
      if (this.traffic_violation.length > 0) {
        this.traffic_violation.forEach((data) => {
          this.totalFine += Number(data.FineAmount);
          this.paidFine += Number(data.AmountPaid);
        });
      } else {
        this.totalFine = 0;
      }
    },
  },
  methods: {
    searchVehicle() {
      this.$store.dispatch("get_traffic_violation", {
        registrationNumber: this.vehicleNumber,
      });
    },
  },
  computed: {
    traffic_violation() {
      return this.$store.state.traffic_violation || [];
    },
    makingAJAX() {
      return this.$store.state.makingAJAX || false;
    },
  },
};
</script>

<style scoped>
.label {
  color: gray;
  font-size: 12px;
}
</style>
